/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
const classes = {
    POPUP: `forge-calendar-dropdown__popup`
};
export const CALENDAR_DROPDOWN_CONSTANTS = {
    classes
};
